//---------- BurgerMneu / Dropdown ----------//

$(document).ready(function () {
  $(".m_button").click(function () {
    $("body").toggleClass("active");
    console.log("active");
    $(".hamBurger-menu").toggleClass("open-menu");

    // Add the following lines to prevent body scrolling
    if ($("body").hasClass("active")) {
      $("body").css("overflow", "hidden");
    } else {
      $("body").css("overflow", "");
    }
  });
});

//------------------------contact dropdown-----------------------------//

document.addEventListener("DOMContentLoaded", function () {
  var contactDropdownDesktop = document.getElementById(
    "contact-dropdown-desktop"
  );
  var contactDropdownMobile = document.getElementById(
    "contact-dropdown-mobile"
  );
  var menu = document.getElementById("dropdownMenu");
  var closeBtn = document.querySelector(".hm-dropdown-close");
  var overlay = document.querySelector(".overlay"); // Ensure the overlay element is selected

  function showFade() {
    $(overlay).fadeIn("slow");
  }

  function hideFade() {
    $(overlay).fadeOut("slow");
  }

  function toggleMenu(event) {
    event.stopPropagation(); // Prevent the event from reaching the document click listener

    if (menu.classList.contains("show")) {
      menu.classList.remove("show");
      hideFade(); // Call hideFade when hiding the menu
      setTimeout(function () {
        menu.style.display = "none";
      }, 500); // Match the duration of the transition
    } else {
      menu.style.display = "block";
      setTimeout(function () {
        menu.classList.add("show");
        showFade(); // Call showFade when showing the menu
      }, 10); // Small delay to ensure display:block is applied before the transition starts
    }
  }

  if (contactDropdownDesktop) {
    contactDropdownDesktop.addEventListener("click", toggleMenu);
  }

  if (contactDropdownMobile) {
    contactDropdownMobile.addEventListener("click", toggleMenu);
  }

  // Add event listener to the close button
  if (closeBtn) {
    closeBtn.addEventListener("click", function () {
      menu.classList.remove("show");
      hideFade(); // Call hideFade when hiding the menu
      setTimeout(function () {
        menu.style.display = "none";
      }, 500); // Match the duration of the transition
    });
  }

  // Hide dropdown when clicking outside of it
  document.addEventListener("click", function (event) {
    if (
      !menu.contains(event.target) &&
      (!contactDropdownDesktop ||
        !contactDropdownDesktop.contains(event.target)) &&
      (!contactDropdownMobile || !contactDropdownMobile.contains(event.target))
    ) {
      if (menu.classList.contains("show")) {
        menu.classList.remove("show");
        hideFade(); // Call hideFade when hiding the menu
        setTimeout(function () {
          menu.style.display = "none";
        }, 500); // Match the duration of the transition
      }
    }
  });

  // Prevent event propagation when clicking inside the menu
  if (menu) {
    menu.addEventListener("click", function (event) {
      event.stopPropagation();
    });
  }

  // Close menu and hide overlay when pressing the Esc key
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      if (menu.classList.contains("show")) {
        menu.classList.remove("show");
        hideFade(); // Call hideFade when hiding the menu
        setTimeout(function () {
          menu.style.display = "none";
        }, 500); // Match the duration of the transition
      }
    }
  });

  // Add event listener to anchor tags within the dropdown menu
  var menuLinks = menu.querySelectorAll("a");
  menuLinks.forEach(function (link) {
    link.addEventListener("click", function () {
      menu.classList.remove("show");
      hideFade(); // Call hideFade when hiding the menu
      setTimeout(function () {
        menu.style.display = "none";
      }, 500); // Match the duration of the transition
      // Hide the hamburger menu and remove the active class from the body
      $(".hamBurger-menu").removeClass("open-menu");
      $("body").removeClass("active").css("overflow", "");
    });
  });
});

//-------------------tab link active careers page-------------------//

document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.querySelectorAll(".tab-list li");
  var sections = document.querySelectorAll(".opportunity-wrap");

  // Function to show a section
  function showSection(index) {
    sections.forEach(function (section, idx) {
      section.style.display = idx === index ? "block" : "none";
    });
  }

  // Initially show the first section
  showSection(0);

  tabs.forEach(function (tab, index) {
    tab.addEventListener("click", function () {
      showSection(index);

      tabs.forEach(function (tab) {
        tab.classList.remove("tab-active");
      });

      tab.classList.add("tab-active");
    });
  });
});

//--------------nav-menuitem-active-------------//

document.addEventListener("DOMContentLoaded", function () {
  var currentUrl = window.location.href.replace(/\/$/, ""); // Remove trailing slash from current URL

  var navLinks = document.querySelectorAll(".nav-menu-active a");

  navLinks.forEach(function (link) {
    var href = link.href.replace(/\/$/, ""); // Remove trailing slash from link href

    if (href === currentUrl) {
      link.parentElement.classList.add("nav-active"); // Adding active class to parent li
    }
  });
});

//----------------what we do page anumation-----------------//

// Function to handle intersection changes
function handleIntersection(entries, observer) {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      // Add your animation class here
      entry.target.classList.add("active");

      // Once animation is applied, you may want to disconnect the observer
      observer.unobserve(entry.target);
    }
  });
}
// Create a new intersection observer
const observer = new IntersectionObserver(handleIntersection, {
  root: null, // viewport
  rootMargin: "0px", // no margin
  threshold: 0.5, // 50% of the element visible
});

// Select the elements you want to observe
const elementsToObserve = document.querySelectorAll(".svganimate");

// Start observing each element
elementsToObserve.forEach((element) => {
  observer.observe(element);
});

//----------contactfrom label moving upward-------//
$(document).ready(function () {
  $(".text-field-input").on("focus", function () {
    $(this).closest(".field-wrapper").addClass("focused");
  });

  $(".text-field-input").on("blur", function () {
    if ($(this).val() === "") {
      $(this).closest(".field-wrapper").removeClass("focused");
    }
  });
});

//--------------contactform error style for input--------------//

document.addEventListener("DOMContentLoaded", function () {
  document.addEventListener(
    "wpcf7invalid",
    function (event) {
      // Check if invalidFields is defined and is an array
      const invalidFields =
        event.detail.apiResponse && event.detail.apiResponse.invalidFields;

      if (Array.isArray(invalidFields)) {
        invalidFields.forEach(function (field) {
          const inputElement = document.querySelector(
            `[name="${field.into.replace(/^\./, "")}"]`
          );
          if (inputElement) {
            inputElement.classList.add("wpcf7-not-valid");
          }
        });
      }
    },
    false
  );
});

//gsap
document.addEventListener("DOMContentLoaded", function () {
  // const textElement = document.querySelector('.content-clr-transition');
  // const words = textElement.innerText.split(' ');
  // let currentIndex = 0;
  const growthContainer = document.querySelector(".growth-bp-container");
  if (growthContainer) {
    gsap.registerPlugin(ScrollTrigger);

    // Pin the growth-bp-container
    gsap.to(".growth-bp-container", {
      scrollTrigger: {
        trigger: ".growth-bp-container",
        start: "center center",
        end: "+=150%",
        pin: true,
        scrub: true,
      },
    });
  }
  // Animate text color transition on scroll
  // ScrollTrigger.create({
  //   trigger: textElement,
  //   start: "top center",
  //   end: "+=55%",
  //   onUpdate: self => {
  //     const progress = self.progress;
  //     const totalWords = words.length;
  //     const wordsPerStep = 5;
  //     const newIndex = Math.floor(progress * totalWords / wordsPerStep) * wordsPerStep;

  //     if (newIndex !== currentIndex) {
  //       currentIndex = newIndex;
  //       textElement.innerHTML = words.map((word, index) => {
  //         if (index >= currentIndex && index < currentIndex + wordsPerStep) {
  //           return `<span class="word-active">${word}</span>`;
  //         } else {
  //           return word;
  //         }
  //       }).join(' ');
  //     }
  //   }
  // });

  // Responsive animations for growth-item-content
  const GrowthItemcontent = document.querySelector(".growth-item-content");
  if (GrowthItemcontent) {
    const mm = gsap.matchMedia();

    gsap.to(".growth-item-content", {
      y: "-50%", // Move upwards to its final position
      scrollTrigger: {
        trigger: ".growth-bp-container",
        start: "center center",
        end: "+=150%",
        scrub: true,
      },
    });

    mm.add("(max-width:1199px)", function () {
      gsap.to(".growth-item-content-div", {
        y: "-0%", // Move downwards for small screens
        scrollTrigger: {
          trigger: ".growth-bp-container",
          start: "center center",
          end: "+=150%",
          scrub: true,
        },
      });
    });

    mm.add("(max-width: 474px)", function () {
      gsap.to(".growth-item-content", {
        y: "-50%", // Move downwards for small screens
        scrollTrigger: {
          trigger: ".growth-bp-container",
          start: "center center",
          end: "+=200%",
          scrub: true,
        },
      });
    });
  }
  const moveLeft = document.querySelector(".move-left");
  const moveRight = document.querySelector(".move-right");
  const moveDownGrp = document.querySelector(".move-down-grp");
  const animationSvgHeading = document.querySelector(".animation-svg-heading");

  // Create a timeline for the sequence
  if (moveLeft && moveRight && moveDownGrp && animationSvgHeading) {
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: ".growth-item-content",
        start: "center center",
        end: "+=150%",
        scrub: 1,
      },
    });

    // Move .move-left left and down, .move-right right and down, and .move-down-grp right simultaneously
    tl.to([".move-left", ".move-right", ".move-down-grp"], {
      x: (i, target) => {
        if (target.classList.contains("move-left")) {
          return -18;
        } else if (target.classList.contains("move-right")) {
          return 64;
        } else if (target.classList.contains("move-down-grp")) {
          return 20; // Adjust the value to move right slightly
        } else {
          return 0;
        }
      },
      y: (i, target) =>
        target.classList.contains("move-left") ||
          target.classList.contains("move-right")
          ? 26
          : 6, // Move down slightly for .move-left and .move-right
      duration: 7, // Adjust the duration as needed
    });

    // Move all three elements down simultaneously and show .animation-svg-heading
    tl.to([".move-left", ".move-right", ".move-down-grp"], {
      y: "+=154",
      duration: 7, // Adjust the duration as needed
      delay: 5,
    }).to(
      ".animation-svg-heading",
      {
        opacity: 1,
        duration: 2,
      },
      "<"
    ); // Use "<" to start this animation at the same time as the previous one

    // Rotate the specified elements in the SVG groups after move-down-grp animation completes
    tl.to(".enterprise-grp .rotate-target, .business-grp .rotate-target", {
      rotation: 180, // Rotate right
      transformOrigin: "center center",
      duration: 30,
      ease: "power2.out", // Optional easing function
    }).to(
      ".strategic-grp .rotate-target",
      {
        rotation: -180,
        transformOrigin: "center center",
        duration: 30,
        ease: "power2.out",
      },
      "<"
    );
    tl.to(
      ".main-circle-grp .rotate-target",
      {
        rotation: 108,
        transformOrigin: "center center",
        duration: 30,
        ease: "power2.out",
      },
      "<"
    );
  }
});

//--------------------------------------tab--------------------------------------//
document.addEventListener("DOMContentLoaded", function () {
  var tabWrappers = document.querySelectorAll(".tab-wrapper");

  if (tabWrappers !== null) {
    tabWrappers.forEach(function (tabWrapper) {
      var tabBlocks = tabWrapper.querySelectorAll(".tab-block");

      if (tabBlocks !== null) {
        tabBlocks.forEach(function (tabBlock) {
          var tabMnu = tabBlock.querySelectorAll(".tab-menu li");
          var tabContent = tabBlock.querySelectorAll(
            ".tab-content > .tab-items"
          );

          tabContent.forEach(function (content, i) {
            if (i !== 0) {
              content.style.display = "none";
            }
          });

          tabMnu.forEach(function (menu, i) {
            if (tabContent[i]) {
              // Ensure tabContent[i] exists
              menu.setAttribute("data-tab", "tab" + i);
              tabContent[i].setAttribute("data-tab", "tab" + i);
            }
          });

          tabMnu.forEach(function (menu) {
            menu.addEventListener("click", function () {
              var tabData = this.getAttribute("data-tab");

              tabContent.forEach(function (content) {
                content.style.display = "none";
              });

              var tabItem = tabBlock.querySelector(
                ".tab-content > .tab-items[data-tab=" + tabData + "]"
              );
              if (tabItem !== null) {
                tabItem.style.display = "block";
              }

              var activeTab = tabBlock.querySelector(".tab-menu li.tab-active");
              if (activeTab !== null) {
                activeTab.classList.remove("tab-active");
              }
              this.classList.add("tab-active");
            });
          });
        });
      }
    });
  }
});

// header scroll
// let lastScrollTop = 0;
// const header = document.querySelector(".site-header");

// window.addEventListener("scroll", () => {
//   const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

//   // Handle the "bounce" effect in Safari
//   if (scrollTop <= 10) {
//     header.classList.remove("nav-up");
//     header.classList.add("nav-down");
//   } else if (scrollTop > lastScrollTop) {
//     // Scrolling down
//     header.classList.remove("nav-down");
//     header.classList.add("nav-up");
//   } else if (scrollTop < lastScrollTop) {
//     // Scrolling up
//     header.classList.remove("nav-up");
//     header.classList.add("nav-down");
//   }

//   lastScrollTop = scrollTop;
// });

//---------- Stciky Header ----------//
document.addEventListener("DOMContentLoaded", () => {
  // (1) Sticky Header
  var didScroll;
  var lastScrollTop = 0;
  var delta = 4;
  var navbarHeight = $(".site-header").outerHeight();

  $(window).on("scroll", function (event) {
    didScroll = true;
  });

  setInterval(function () {
    if (didScroll) {
      hasScrolled();
      didScroll = false;
    }
  }, 250);

  function hasScrolled() {
    var st = $(window).scrollTop();
    if (Math.abs(lastScrollTop - st) <= delta) return;
    if (st > lastScrollTop && st > navbarHeight) {
      // Scroll Down
      $(".site-header").removeClass("nav-down").addClass("nav-up");
    } else {
      // Scroll Up
      if (st + $(window).height() < $(document).height() && st > navbarHeight) {
        $(".site-header").removeClass("nav-up").addClass("nav-down");
      }
    }
    if (st >= 200) {
      $(".site-header").addClass("nav-hiding");
    } else {
      $(".site-header").removeClass("nav-hiding");
    }
    if (st < delta) {
      $(".site-header").removeClass("nav-up nav-down");
    }
    lastScrollTop = st;
  }
});

// smoth scroll for what we do
function scrollToSection(event, sectionID) {
  event.preventDefault();
  const section = document.getElementById(sectionID);
  if (section) {
    section.scrollIntoView({ behavior: "smooth" });
  }
}

// careers
// accordion
var accordions = document.querySelectorAll(".accordion__item--header");
if (accordions !== null) {
  accordions.forEach((header) => {
    header.addEventListener("click", () => {
      const accordionItem = header.closest(".accordion__item");
      const accordionContent = accordionItem.querySelector(
        ".accordion__item--content"
      );
      // Collapse previously opened items
      document.querySelectorAll(".accordion__item").forEach((item) => {
        if (item !== accordionItem && item.classList.contains("active")) {
          item.classList.remove("active");
          item.querySelector(".accordion__item--content").style.maxHeight = 0;
        }
      });

      // Expand or collapse the current item
      if (accordionItem.classList.contains("active")) {
        accordionItem.classList.remove("active");
        accordionContent.style.maxHeight = 0;
      } else {
        accordionItem.classList.add("active");
        accordionContent.style.maxHeight = accordionContent.scrollHeight + "px";

        // Ensure the active item is scrolled into view with padding
        setTimeout(() => {
          // Get the position of the accordion item
          const itemRect = accordionItem.getBoundingClientRect();
          const viewportHeight = window.innerHeight;

          // Calculate the desired scroll position with padding
          const padding = 100; // Adjust the padding value as needed
          const scrollY = window.scrollY;
          const topPosition = itemRect.top + scrollY - padding;

          window.scrollTo({
            top: topPosition,
            behavior: "smooth",
          });
        }, 300); // Adjust the delay if needed to match the animation duration
      }
    });
  });
}

// splide
document.addEventListener("DOMContentLoaded", function () {
  const splideElement = document.querySelector("#splide");
  if (splideElement) {
    new Splide("#splide", {
      type: "loop",
      perPage: 3,
      focus: "center",
      autoplay: true,
      autoWidth: true,
      interval: 2000,
      pagination: false,
      arrows: true,
      drag: true,
      padding: "10%",
      throttle: 300,
      breakpoints: {
        1440: {
          perPage: 1,
          padding: "30%",
        },
      },
    }).mount();
  }
});

// // homepage journy section

document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  if (document.querySelector(".journey-section")) {
    const spantexts = document.querySelectorAll(".animate-span");

    // Fetch the dynamic text from the specified HTML element
    const defaulttextone = document
      .querySelector(".default_text_one")
      .textContent.trim();
    const defaulttexttwo = document
      .querySelector(".default_text_two")
      .textContent.trim();
    const spanoneright = document
      .querySelector(".span-one-right")
      .textContent.trim();
    const spanoneleft = document
      .querySelector(".span-one-left")
      .textContent.trim();

    const spantworight = document
      .querySelector(".span-two-right")
      .textContent.trim();
    const spantwoleft = document
      .querySelector(".span-two-left")
      .textContent.trim();

    // Define the sequence of text changes using dynamic text
    const textChanges = [
      [
        { from: defaulttextone, to: spanoneleft },
        { from: spanoneleft, to: spantwoleft },
      ],
      [
        { from: defaulttexttwo, to: spanoneright },
        { from: spanoneright, to: spantworight }, // Use dynamic text here
      ],
    ];

    // Function to handle text change on completion
    function changeText(span, change) {
      // Replace all occurrences of `change.from` with `change.to`
      const regex = new RegExp(change.from, "g");
      span.textContent = span.textContent.replace(regex, change.to);
    }

    // Function to reset the span to its initial state
    function resetSpan(span, initialText) {
      span.textContent = initialText; // Reset text content
      gsap.set(span, { width: "auto", display: "inline-block" });
    }

    // Iterate over each span element
    spantexts.forEach((span, index) => {
      // Check if `index` is valid
      if (index >= textChanges.length) {
        console.warn(`No text changes defined for span index ${index}`);
        return;
      }

      const changes = textChanges[index];
      const initialText = span.textContent; // Store initial text content

      // Create GSAP timeline for each span
      const timeline = gsap.timeline({
        scrollTrigger: {
          trigger: span,
          start: "top 80%",
          end: "top 20%",
          toggleActions: "play none none none",
          onEnter: () => {
            // Restart animation from the beginning
            resetSpan(span, initialText);
            timeline.restart(true); // Restart timeline from the beginning
          },
          onLeaveBack: () => {
            // Optionally, reset the animation if leaving backward
            resetSpan(span, initialText);
          },
        },
      });

      changes.forEach((change, changeIndex) => {
        timeline
          .to(span, {
            duration: 1,
            width: 0, // Shrink width to 0
            ease: "power1.inOut",
            overflow: "hidden",
            delay: 2,
            onComplete: () => changeText(span, change),
          })
          .to(span, {
            duration: 1,
            width: "auto", // Expand width to auto
            ease: "power1.inOut",
            display: "inline-block", // Ensure inline-block for smooth transition
          });
      });
    });
  }
});
